import { cn } from '@/lib/utils';

/** The hex mark and HIVE wordmark, in NeuroForge's neon style. */
export function Brand({ className, size = 'md' }: { className?: string; size?: 'md' | 'lg' }) {
  const lg = size === 'lg';
  return (
    <div className={cn('flex items-center gap-3', className)}>
      <div
        aria-hidden
        className={cn(
          'grid shrink-0 place-items-center border border-magenta text-magenta text-shadow-glow-magenta shadow-[inset_0_0_10px_rgb(255_43_214/0.35),0_0_10px_rgb(255_43_214/0.25)] [clip-path:polygon(0_0,calc(100%-8px)_0,100%_8px,100%_100%,8px_100%,0_calc(100%-8px))]',
          lg ? 'size-14 text-2xl' : 'size-[34px] text-base',
        )}
      >
        ⬡
      </div>
      <div className="flex flex-col gap-[3px] leading-none">
        <span
          className={cn(
            'animate-flicker font-display font-black tracking-[0.12em] text-cyan text-shadow-glow-cyan',
            lg ? 'text-4xl' : 'text-lg',
          )}
        >
          HI<span className="text-magenta text-shadow-glow-magenta">VE</span>
        </span>
        <span className="font-mono text-[9px] font-medium tracking-[0.32em] text-muted uppercase">The Hive studio</span>
      </div>
    </div>
  );
}
